import React__default, { useContext } from 'react';
import Typography from './Typography.js';
import classNames from './../external_lib/classnames/index.js';
import LoadingOutlined from './../external_lib/@ant-design/icons/LoadingOutlined.js';
import { ThemeContext } from '../provider.js';
import { LazyMotion } from './../external_lib/framer-motion/dist/es/components/LazyMotion/index.js';
import { domAnimation } from './../external_lib/framer-motion/dist/es/render/dom/features-animation.js';
import { m } from './../external_lib/framer-motion/dist/es/render/dom/motion-minimal.js';

function Button(_a) {
    var loading = _a.loading, variant = _a.variant, size = _a.size, fullWidth = _a.fullWidth, _b = _a.disabled, disabled = _b === void 0 ? false : _b, rightIcon = _a.rightIcon, leftIcon = _a.leftIcon, classes = _a.classes, children = _a.children, _c = _a.type, type = _c === void 0 ? 'black' : _c, onClick = _a.onClick;
    var handleClick = function (event) {
        event.preventDefault();
        if (loading || disabled)
            return;
        onClick && onClick(event);
    };
    var getButtonTextSize = function (size) {
        switch (size) {
            case 'sm':
                return 'buttonThree';
            case 'md':
                return 'buttonTwo';
            case 'lg':
                return 'buttonOne';
            default:
                return 'button';
        }
    };
    var RightIcon = rightIcon;
    var LeftIcon = leftIcon;
    var theme = useContext(ThemeContext).theme;
    return (React__default.createElement(LazyMotion, { features: domAnimation },
        React__default.createElement(m.button, { whileHover: loading || disabled ? {} : { scale: 1.02 }, whileTap: loading || disabled ? {} : { scale: 0.93 }, onClick: handleClick, className: classNames('button', "button-variant--".concat(variant), "button-size--".concat(size), "button-option--".concat(type), classes, {
                'button--fullwidth': fullWidth,
                'button--disabled': disabled,
                'button--loading': loading
            }) }, loading ? (React__default.createElement(LoadingOutlined, { className: classNames({
                'counter-loading--solid': variant === 'solid',
                'counter-loading--rest': variant !== 'solid'
            }) })) : (React__default.createElement(React__default.Fragment, null,
            leftIcon ? (React__default.createElement(LeftIcon, { className: "left-icon", color: theme.colors.primaryColor })) : null,
            React__default.createElement(Typography, { classes: "button-text", variant: getButtonTextSize(size) }, children),
            rightIcon ? (React__default.createElement(RightIcon, { className: "right-icon", color: theme.colors.primaryColor })) : null)))));
}

export { Button as default };
//# sourceMappingURL=Button.js.map
